var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.787109,
    y: 0.5,
    width: 25.0076,
    height: 25,
    rx: 12.5,
    fill: "#456786"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7912 18.8337C17.1006 18.8337 17.3973 18.7107 17.6161 18.4919C17.8349 18.2732 17.9578 17.9764 17.9578 17.667V14.7503L15.0412 17.0837V15.3337H10.9578V14.167H15.0412V12.417L17.9578 14.7503V10.667L14.4578 7.16699H9.79118C9.48176 7.16699 9.18501 7.28991 8.96622 7.5087C8.74743 7.72749 8.62451 8.02424 8.62451 8.33366V17.667C8.62451 17.9764 8.74743 18.2732 8.96622 18.4919C9.18501 18.7107 9.48176 18.8337 9.79118 18.8337H16.7912ZM13.8745 8.33366L16.7912 11.2503H13.8745V8.33366Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.665f5e34522bd74fdd2265ddd7c9b1ea.svg";
export { ForwardRef as ReactComponent };